  import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
    TableContainer,
    Paper,
    IconButton,
    Tooltip
} from "@mui/material";
import { useEffect, useState } from "react";
import { getContrato } from "../../../management/contract/functions";
import { formatarData } from "../../contracts/configs/functions";
import { LoadingTableRow } from "../../../../common/LoadingTableRow";
import { useCommonItems } from "../../../../../contexts/CommonItensProvider";
import { EmptyTableRow } from "../../../../common/EmptyTableRow";
import { SettingChipContract } from "../../contracts/components/SettingChipContract";
import SectionTitle from "../../../../common/SectionTitle";
import { Visibility } from "@mui/icons-material";
import { ContractForm } from "../../contracts/components/ContractForm";
const Row = ({contrato, handleOpenVisuForm}) => {
    const chipConfig = SettingChipContract(contrato);
    const qtdVidas = contrato.qtd_colaboradores_admin + contrato.qtd_colaboradores;
           return (
            <>
            {chipConfig.color === 'error' && 
            <TableRow>
            <TableCell align="left" sx={{ fontSize: '0.9rem' }}>
                {contrato?.nome}
            </TableCell>

            <TableCell align="left">
                {contrato
                    ? `${formatarData(contrato.inicio_contrato)} - ${formatarData(contrato.fim_contrato)}`
                    : '-'}
            </TableCell>
            <TableCell align="left">
                <Chip size="small" variant="outlined" label={chipConfig.label} color={chipConfig.color} />
            </TableCell>
                    
            <TableCell>
               {contrato? `${qtdVidas}` : '-'}
            </TableCell>

            <TableCell><Tooltip title={'Visualizar Contrato'}>
                        <IconButton aria-label="Visualizar" onClick={handleOpenVisuForm} size="small">
                            <Visibility color="primary" />
                           </IconButton>
                           </Tooltip></TableCell>
       </TableRow>
    }
       </>
         );
        }


export function TableContracts(){
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [contratos, setContratos] = useState([]);
    const { exibirAlerta } = useCommonItems();
    const [selectedContract, setSelectedContract] = useState(null);
    const [openForm, setOpenForm] = useState(false);

    const handleOpenVisuForm = (contract) => {
      setSelectedContract(contract);
      setOpenForm(true);
    };

    async function carregaContratos(ativo) {
      try {
        const res = await getContrato({ limit: 10 });
        if (ativo) setContratos(res?.data.data ?? []);
      } catch (error) {
        if (ativo) {
          exibirAlerta("Erro", "Erro ao carregar contratos", "error");
          setContratos([]);
        }
      } finally {
        if (ativo) setIsLoading(false);
      }
    }

    useEffect(() => {
      let ativo = true;
      carregaContratos(ativo);

      return () => {
        ativo = false;
      };
    }, []);

    return(
        <>
  <Grid container  sx={{marginTop:2}}>
    <Grid item xs={10} mb={2}>
        <SectionTitle title="Gestão de contratos" subtitle="Gerencie os contratos que estão vencidos ou para vencer" />
    </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table aria-label="Contratos">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nome do Contrato</TableCell>
                                    <TableCell>Período</TableCell>
                                    <TableCell>Prazo restante</TableCell>
                                    <TableCell>Quantidade de vidas</TableCell>
                                    <TableCell align="center" />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ? (
                                    <LoadingTableRow />
                                ) : contratos.length > 0 ? (
                                    contratos.map((contrato) => (
                                    <Row 
                                    key={contrato.id} 
                                    contrato={contrato}
                                    handleOpenVisuForm={() => handleOpenVisuForm(contrato)}
                                     />
                                    ))
                                ) : (
                                    <EmptyTableRow colSpan={7} />
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        
            <ContractForm
                open={openForm}
                setOpen={setOpenForm}
                contrato={selectedContract}
                actionsAllowed={true}
                onSuccess={carregaContratos}
                visualizar = {true}
            />
        </>
    )
}

export default TableContracts
 